import { AccessPermissions } from '@types';
import { LoadingPage } from 'components/Loading/LoadingPage';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTE_HOME, ROUTE_REQUESTS } from 'routes';

import { useCurrentUserProfilePermissions } from '../../../contexts/OidcContext/OidcContext.selectors';

interface RequireAuthProps {
    children: JSX.Element;
    requiredPermission?: AccessPermissions.REQUEST_PAGE | AccessPermissions.GANTT_PAGE;
}

// @see https://stackblitz.com/github/remix-run/react-router/tree/main/examples/auth?file=src/App.tsx
export function RequirePermission({ children, requiredPermission }: RequireAuthProps) {
    const permissions = useCurrentUserProfilePermissions();

    if (!permissions?.length) {
        return <LoadingPage />;
    }

    if (requiredPermission) {
        const hasRequiredPermission = permissions && permissions?.includes(requiredPermission);
        const navigateTo =
            !hasRequiredPermission && requiredPermission === AccessPermissions.REQUEST_PAGE
                ? ROUTE_HOME
                : ROUTE_REQUESTS;

        if (!hasRequiredPermission) {
            return <Navigate to={navigateTo} />;
        }
    }

    return children;
}
